export enum SessionStorageKeys {
  ShopifyReturnParams = 'shopify_return_params',
}
